<template>
    <div class="w-full py-4 column_start_start">
        <div class="row_center_start w-full flex-wrap">
            <text class="font-base font-semibold text-[#AAA] mr-3">取餐時間</text>
            <text class="font-base mr-3">{{ deliveryDate }}</text> <text class="font-base">{{ deliveryTime }}</text>
        </div>
        <div class="w-full h-1 border-b border-dashed border-[#AAA] my-4"></div>
        <div class="column_start_start w-full flex-wrap">
            <!-- TODO: 店家訊息 -->
            <text class="font-base">取餐時，請提供自取號碼。</text>
            <text class="font-base">付款後，依現場排序，完成取餐。</text>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        deliveryPhone() {
            return this.getPayment.phone
        }
    }
}
</script>
<style lang="">

</style>